var _defs, _path, _path2, _circle, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKnegMini(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-linejoin: round;\n        stroke-width: 4.07px;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #231f20;\n        stroke-linecap: round;\n      }\n\n      .cls-2 {\n        stroke-miterlimit: 10;\n        stroke-width: 4.07px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.68,42.51l-6.65-4.77-4.05-7.36c-3.2-5.83-9.33-9.45-15.97-9.45H17.07c-2.68,0-4.85,2.17-4.85,4.85v19.09h-.97c-.65,0-1.18,.53-1.18,1.18v3.67c0,1.57,1.27,2.84,2.84,2.84h3.96s0,0,0,0c0-3.59,2.91-6.5,6.5-6.5s6.5,2.91,6.5,6.5h0s20.25,0,20.25,0c0,0,0,0,0,0,0-3.59,2.91-6.5,6.5-6.5s6.5,2.91,6.5,6.5c0,0,0,0,0,0h3.81c1.65,0,2.98-1.34,2.98-2.98v-4.65c0-.96-.46-1.87-1.25-2.43Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42,27.1c4.21,0,8.09,2.29,10.12,5.98l2.56,4.66h-12.68v-10.64Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 56.62,
    cy: 52.56,
    r: 6.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 23.38,
    cy: 52.56,
    r: 6.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnegMini);
export default __webpack_public_path__ + "static/media/kneg-mini.646b9e147b5a38368d811ebe5ae18f46.svg";
export { ForwardRef as ReactComponent };